const TOKEN_KEY = 'mewes_token'
const USER_KEY = 'mewes_user'

export const API_BASE = process.env.NEXT_PUBLIC_API_URL || ''

// CONFIRMADO (bug real): el proxy de rewrites() de Next.js (usado por defecto
// cuando se llama a través de `API_BASE` relativo, ver next.config.mjs) se
// cuelga indefinidamente al reenviar subidas multipart de archivos grandes
// (~15MB+) — probado con archivos reales de 21-24MB: directo al backend (con o
// sin túnel ngrok) responden en ~30s, pero a través del rewrite de Next.js
// (`next dev`, cualquier destino, local o ngrok) nunca llega respuesta ni
// siquiera a los 280s. Para subidas de archivos se debe llamar al backend
// DIRECTO desde el navegador (el backend ya tiene CORS habilitado para
// localhost y *.ngrok.app — ver `app.use(cors(...))` en backend/server.js),
// nunca a través de `API_BASE` relativo. Deriva la URL directa según el origen
// desde el que se está accediendo al frontend: si es *.ngrok.app, el backend
// está en "back" + ese mismo dominio (mewes.ngrok.app -> backmewes.ngrok.app);
// si es localhost/LAN, el backend está en el mismo host, puerto 4046.
export function getBackendDirectUrl(): string {
  if (typeof window === 'undefined') return API_BASE
  const { protocol, hostname } = window.location
  if (hostname.endsWith('.ngrok.app')) return `${protocol}//back${hostname}`
  return `${protocol}//${hostname}:4046`
}

export interface AuthUser {
  id: string
  nombre: string
  apellido: string
  email: string
  rol: string
}

export function getToken(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(TOKEN_KEY)
}

export function setAuth(token: string, user: AuthUser): void {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getUser(): AuthUser | null {
  if (typeof window === 'undefined') return null
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try { return JSON.parse(raw) } catch { return null }
}

export function isAuthenticated(): boolean {
  return !!getToken()
}

export function authHeaders(): Record<string, string> {
  const token = getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Detecta si una respuesta/mensaje de error corresponde a un token inválido o expirado
// y, de ser así, limpia la sesión y redirige directamente al login.
export function handleAuthError(status?: number, errorMessage?: string): boolean {
  const mensajeToken = typeof errorMessage === 'string' && /token/i.test(errorMessage) && (/inv[aá]lid/i.test(errorMessage) || /expirad/i.test(errorMessage))
  if (status === 401 || status === 403 || mensajeToken) {
    clearAuth()
    if (typeof window !== 'undefined') {
      window.location.href = '/login'
    }
    return true
  }
  return false
}
